export default __webpack_public_path__ + "static/Riot_Shield-e6605737f1c40308dd095e45911f6b81.png";